module.exports = __webpack_public_path__ + "img/exception.61183cb2.svg";